import statsig from './statsig';
import { initStatsigVariants } from './statsigVariants';

/**
 * Initialize Statsig variants and set up event tracking.
 */
export async function initTracking() {
  // Initialize variants first (for flash prevention)
  await initStatsigVariants();

  // Track page view
  statsig.logEvent('page_view', null, {
    url: window.location.pathname,
    title: document.title,
    referrer: document.referrer || null,
  });

  // Track button clicks via event delegation
  document.addEventListener('click', event => {
    const button = event.target.closest(
      'button, [role="button"], .wp-block-button__link',
    );
    if (button && button.tagName !== 'A') {
      statsig.logEvent('button_click', null, {
        text: button.textContent?.trim().slice(0, 100) || null,
        id: button.id || null,
        classes: button.className || null,
        url: window.location.pathname,
      });
    }
  });

  // Track link clicks via event delegation
  document.addEventListener('click', event => {
    const link = event.target.closest('a');
    if (link) {
      statsig.logEvent('link_click', null, {
        text: link.textContent?.trim().slice(0, 100) || null,
        id: link.id || null,
        href: link.getAttribute('href') || null,
        url: window.location.pathname,
      });
    }
  });

  // Track form submissions via event delegation
  document.addEventListener('submit', event => {
    const form = event.target.closest('form');
    if (form) {
      statsig.logEvent('form_submit', null, {
        id: form.id || null,
        action: form.getAttribute('action') || null,
        url: window.location.pathname,
      });
    }
  });

  // Track scroll depth milestones
  trackScrollDepth();

  // Track time on page
  trackTimeOnPage();
}

/**
 * Track scroll depth at 25%, 50%, 75%, 100% milestones.
 */
function trackScrollDepth() {
  const milestones = [25, 50, 75, 100];
  const reached = new Set();
  let ticking = false;

  const checkScroll = () => {
    const scrollTop = window.scrollY;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrollPercent = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;

    milestones.forEach(milestone => {
      if (scrollPercent >= milestone && !reached.has(milestone)) {
        reached.add(milestone);
        statsig.logEvent('scroll_depth', milestone, {
          url: window.location.pathname,
        });
      }
    });

    ticking = false;
  };

  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(checkScroll);
      ticking = true;
    }
  });
}

/**
 * Track total time spent on page when user leaves.
 */
function trackTimeOnPage() {
  const startTime = Date.now();

  window.addEventListener('pagehide', () => {
    const timeSpent = Math.round((Date.now() - startTime) / 1000);
    statsig.logEvent('time_on_page', timeSpent, {
      url: window.location.pathname,
    });
  });
}
